import api from "../../config/api";
import { handleApiError } from "@/utils/ErrorHandler";

const state = {
    preferredPersons: [],
    loading: false,
    error: null,
};

const mutations = {
    SET_PREFERRED_PERSONS(state, data) {
        state.preferredPersons = data;
    },
    SET_LOADING(state, value) {
        state.loading = value;
    },
    SET_ERROR(state, error) {
        state.error = error;
    },
};

const actions = {
    async fetchPreferredPersons({ commit }, workgroupId) {
        commit("SET_LOADING", true);
        commit("SET_ERROR", null);
        try {
            const response = await api.get(`/activity-workgroups/${workgroupId}/preferred-persons`);
            const data = response.data?.output || [];
            commit("SET_PREFERRED_PERSONS", data);
            return data;
        } catch (error) {
            const message = handleApiError(error, "Failed to fetch preferred persons");
            commit("SET_ERROR", message);
            throw new Error(message);
        } finally {
            commit("SET_LOADING", false);
        }
    },

    async savePreferredPersons({ commit }, { workgroupId, personIds }) {
        commit("SET_LOADING", true);
        commit("SET_ERROR", null);
        try {
            const response = await api.post(`/activity-workgroups/${workgroupId}/preferred-persons`, {
                person_ids: personIds,
            });
            return response.data;
        } catch (error) {
            const message = handleApiError(error, "Failed to save preferred persons");
            commit("SET_ERROR", message);
            throw new Error(message);
        } finally {
            commit("SET_LOADING", false);
        }
    },
};

const getters = {
    preferredPersons: (state) => state.preferredPersons,
    preferredPersonsLoading: (state) => state.loading,
    preferredPersonsError: (state) => state.error,
};

export default {
    state,
    mutations,
    actions,
    getters,
};
